import React, { Children } from 'react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <AnimatedSection staggerChildren className="py-16 md:py-24 px-6 max-w-3xl mx-auto" data-id="element-3">
      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-charcoal/5" data-id="element-4">
        <h2 className="text-3xl font-bold text-charcoal mb-8 text-center" data-id="element-5">
          ¿Para Quién Es Esto?
        </h2>

        <div className="space-y-4 mb-12" data-id="element-6">
          <AnimatedItem data-id="element-7">
            <div className="flex items-start gap-4" data-id="element-8">
              <div className="mt-1 bg-sage/10 p-1.5 rounded-full flex-shrink-0" data-id="element-9">
                <CheckIcon className="w-5 h-5 text-sage" data-id="element-10" />
              </div>
              <p className="text-charcoal/80 text-lg" data-id="element-11">
                Mujeres que sienten que el estrés las está sobrepasando
                físicamente.
              </p>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-12">
            <div className="flex items-start gap-4" data-id="element-13">
              <div className="mt-1 bg-sage/10 p-1.5 rounded-full flex-shrink-0" data-id="element-14">
                <CheckIcon className="w-5 h-5 text-sage" data-id="element-15" />
              </div>
              <p className="text-charcoal/80 text-lg" data-id="element-16">
                Personas que han sufrido ataques de pánico y viven con miedo a
                que se repita.
              </p>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-17">
            <div className="flex items-start gap-4" data-id="element-18">
              <div className="mt-1 bg-sage/10 p-1.5 rounded-full flex-shrink-0" data-id="element-19">
                <CheckIcon className="w-5 h-5 text-sage" data-id="element-20" />
              </div>
              <p className="text-charcoal/80 text-lg" data-id="element-21">
                Profesionales que necesitan mantener la compostura bajo presión
                extrema.
              </p>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-22">
            <div className="flex items-start gap-4" data-id="element-23">
              <div className="mt-1 bg-sage/10 p-1.5 rounded-full flex-shrink-0" data-id="element-24">
                <CheckIcon className="w-5 h-5 text-sage" data-id="element-25" />
              </div>
              <p className="text-charcoal/80 text-lg" data-id="element-26">
                Madres y trabajadoras que ya no tienen energía para lidiar con
                el agotamiento mental.
              </p>
            </div>
          </AnimatedItem>
        </div>

        <div className="pt-8 border-t border-charcoal/10" data-id="element-27">
          <h3 className="text-xl font-bold text-charcoal mb-6 text-center" data-id="element-28">
            Esto NO es para ti si...
          </h3>
          <div className="space-y-4" data-id="element-29">
            <AnimatedItem data-id="element-30">
              <div className="flex items-start gap-4" data-id="element-31">
                <div className="mt-1 bg-terracotta/10 p-1.5 rounded-full flex-shrink-0" data-id="element-32">
                  <XIcon className="w-5 h-5 text-terracotta" data-id="element-33" />
                </div>
                <p className="text-charcoal/70" data-id="element-34">
                  Buscas una cura milagrosa sin seguir instrucciones físicas.
                </p>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-35">
              <div className="flex items-start gap-4" data-id="element-36">
                <div className="mt-1 bg-terracotta/10 p-1.5 rounded-full flex-shrink-0" data-id="element-37">
                  <XIcon className="w-5 h-5 text-terracotta" data-id="element-38" />
                </div>
                <p className="text-charcoal/70" data-id="element-39">
                  Prefieres soluciones teóricas largas en lugar de herramientas
                  de acción rápida.
                </p>
              </div>
            </AnimatedItem>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}